module.exports = __webpack_public_path__ + "img/szechenyiplus_teszt.a642707f.png";